/*  MUI  */
import { Box, Button, Paper } from '@mui/material';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/* Hooks */
import { useIsOnTrialFromPartnerTenantInfo } from 'hooks/dataAccess/Session/isOnTrial';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Internal  */
import ScheduleReportButtonWithModal from '../Containers/ScheduleReportButtonWithModal';

export const HeaderActionsSetupReportOrPrint = ({
    reportSetup,
    resetReport,
    savedReportParams,
    noData = false
}) => {
    const { t } = useTranslation();

    const isPrintButtonDisabled = useIsOnTrialFromPartnerTenantInfo();

    return (
        <Paper
            elevation={0}
            variant="outlined"
            className="hidePrint"
            style={{ marginBottom: '8px' }}
            data-testid="headerActionsSetupReportOrPrint"
            data-trackid="headerActionsSetupReportOrPrint"
        >
            <Box
                display="flex"
                justifyContent="space-between"
                flexWrap="wrap"
                gap="8px"
            >
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => resetReport()}
                    data-testid="headerActionsSetupReportOrPrintSetupBtn"
                >
                    {t('Navigation.setup_new_report')}
                </Button>
                <Box display="flex" gap="8px">
                    <DarkTooltip
                        arrow
                        {...(isPrintButtonDisabled
                            ? {
                                  title: t(
                                      'Tooltips.exportFunctionality.disabled'
                                  )
                              }
                            : {})}
                    >
                        <Box data-testid="headerActionsSetupReportOrPrintPrintBtnBox">
                            <Button
                                variant="outlined"
                                size="small"
                                color="primary"
                                disabled={noData || isPrintButtonDisabled}
                                onClick={() => window.print()}
                                data-testid="headerActionsSetupReportOrPrintPrintBtn"
                            >
                                {t('Navigation.print_report')}
                            </Button>
                        </Box>
                    </DarkTooltip>
                    <ScheduleReportButtonWithModal
                        savedReportParams={savedReportParams}
                        reportSetup={reportSetup}
                    />
                </Box>
            </Box>
        </Paper>
    );
};
